import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Gate a route behind auth (and optionally a role list).
 * Usage:
 *   <ProtectedRoute><Dashboard /></ProtectedRoute>
 *   <ProtectedRoute roles={["super_admin","client_admin"]}><Admin /></ProtectedRoute>
 */
export default function ProtectedRoute({ children, roles }) {
  const { loading, session, hasRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="auth-loading"
        className="flex h-screen items-center justify-center text-sm text-muted-foreground"
      >
        Loading…
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Admin-set temporary password: force a new password before anything else.
  if (session.user?.app_metadata?.must_change_password === true) {
    return <Navigate to="/reset-password" replace />;
  }

  if (roles && roles.length > 0 && !hasRole(roles)) {
    return <Navigate to="/forbidden" replace />;
  }

  return children;
}
